<template>
  <div class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-light-gray tw-px-4">
    <div class="tw-w-full tw-max-w-[420px]">
      <div class="tw-mb-8 tw-flex tw-justify-center">
        <Logo type="timeful" />
      </div>
      <v-card class="tw-rounded-xl tw-px-2 tw-py-4">
        <v-card-title class="tw-flex tw-flex-col tw-items-center tw-pb-0">
          <div class="tw-text-2xl tw-font-medium">{{ isSetup ? "Set initial password" : "Sign in" }}</div>
          <div class="tw-mt-1 tw-text-sm tw-font-normal tw-text-dark-gray">
            {{ isSetup ? "Store this generated password in your password manager." : "Use your local Timeful account." }}
          </div>
        </v-card-title>
        <v-card-text class="tw-pt-6">
          <div class="tw-mb-1 tw-text-sm tw-font-medium">Email address</div>
          <v-text-field v-model="email" type="email" solo hide-details="auto" :disabled="isSetup" class="tw-mb-4" />
          <div class="tw-mb-1 tw-text-sm tw-font-medium">Password</div>
          <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" solo hide-details="auto" :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showPassword = !showPassword" @keydown.enter="submit" class="tw-mb-4" />
          <v-btn block color="primary" :loading="submitting" :disabled="!canSubmit || submitting" @click="submit">
            {{ isSetup ? "Create account" : "Sign in" }}
          </v-btn>
          <div v-if="error" class="tw-mt-3 tw-text-sm tw-text-red">{{ error }}</div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { post } from "@/utils"
import { mapMutations } from "vuex"
import Logo from "@/components/Logo.vue"

const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!#$%&*+-=?@"

export default {
  name: "LocalSignIn",
  components: { Logo },
  data() {
    const isSetup = Boolean(this.$route.query.setup)
    return {
      isSetup,
      email: this.$route.query.email || "",
      password: isSetup ? Array.from(crypto.getRandomValues(new Uint32Array(32)), (n) => alphabet[n % alphabet.length]).join("") : "",
      showPassword: isSetup,
      submitting: false,
      error: "",
    }
  },
  computed: {
    canSubmit() {
      return this.email.trim() && this.password.length >= (this.isSetup ? 16 : 1)
    },
  },
  methods: {
    ...mapMutations(["setAuthUser"]),
    async submit() {
      this.submitting = true
      this.error = ""
      try {
        const endpoint = this.isSetup ? "/auth/local/setup" : "/auth/local/sign-in"
        const payload = { email: this.email, password: this.password }
        if (this.isSetup) payload.token = this.$route.query.setup
        const user = await post(endpoint, payload)
        this.setAuthUser(user)
        this.$router.replace(this.$route.query.redirect || "/home")
      } catch (err) {
        this.error = err?.parsed?.error || "Sign-in failed. Please try again."
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
